import { render } from "./theme.vue?vue&type=template&id=08296d84&scoped=true"
import script from "./theme.vue?vue&type=script&lang=js"
export * from "./theme.vue?vue&type=script&lang=js"

import "./theme.vue?vue&type=style&index=0&id=08296d84&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08296d84"]])

export default __exports__